//서버 라우터
export const USER_SERVER = "https://soundpicker.ga/user";
